import "../../utils/customMoment";
import {formatTemporalValue} from "../../utils/formatters";

export const getAttributeValue = attribute => {
  let attributeValue = "";
  if (attribute) {
    if (typeof attribute === "string") {
      attributeValue = attribute;
    } else {
      try {
        attributeValue = JSON.stringify(attribute);
      } catch {
        attributeValue = "";
      }
    }
  }

  return attributeValue;
};

export const formatIdentifyValue = (value, type, timeFormatMap) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const format = timeFormatMap?.[type];
  if (!format) {
    return getAttributeValue(value);
  }

  const formattedTemporalValue = formatTemporalValue(value, type, format);
  if (formattedTemporalValue !== null) {
    return formattedTemporalValue;
  }

  return getAttributeValue(value);
};
